export const FooterTabType = {
    JOIN_US:0,
    DO_BUSINESS: 1
}